import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { ButtonLink } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

interface DetailsLinkOutProps {
  ctaPath?: string;
}

export const DetailsLinkOut = ({ ctaPath }: DetailsLinkOutProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { trackingData } = useHomeownerAppContext();
  const ctaButtonPath = ctaPath || Routes.HOMEOWNER_APP_HOME.path;

  return (
    <ButtonLink
      isExternal={!!ctaPath}
      marginY={700}
      optionalTrackingProperties={{
        ...trackingData,
        feature: 'lead-landing-page',
        page_or_screen_name: 'lead-landing-page',
        track_id: 'lead-landing-try',
      }}
      paddingX={500}
      size="large"
      to={ctaButtonPath}
    >
      {t('share.tryItNow')}
    </ButtonLink>
  );
};
